import { createContext } from 'react';
import type { Brands, Themes } from '@frameio/vapor-theme';
import type {
  AccentNeutralBrand,
  CustomAccentNeutralColors,
  CustomBrand,
} from './types';

type CoreThemeProviderValues = {
  themeName?: Themes;
  brandName?: Brands;
  customBrand?: CustomBrand;
  accentNeutralColors?: CustomAccentNeutralColors;
  accentNeutralBrand?: AccentNeutralBrand;
};

export type ThemeProviderContextValue = CoreThemeProviderValues & {
  outermostThemeProviderValues?: CoreThemeProviderValues;
};

export const ThemeProviderContext =
  createContext<ThemeProviderContextValue>(null);
